// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { DotLoadingIndicator } from '@xingternal/dot-loading-indicator';

import IntersectionObserver from '@xingternal/intersection-observer';

// @ts-ignore
import styles from './LazyLoading.css';

const LAZY_LOAD_OBSERVE_INTERVAL_MS = 500;

class LazyLoading extends React.Component {
  state = {
    isIntersecting: false,
    disabled: false,
  };

  callLazyLoad = () => {
    if (!this.props.loading && this.props.onLazyLoad) {
      this.props.onLazyLoad(this.unobserve);
    }
  };

  onIntersectionChange = ({ isIntersecting }) => {
    this.setState({ isIntersecting });
    if (isIntersecting) {
      this.callLazyLoad();
    }
  };

  componentDidMount() {
    this.lazyLoadIntervalId = window.setInterval(() => {
      if (this.state.isIntersecting) {
        this.callLazyLoad();
      }
    }, LAZY_LOAD_OBSERVE_INTERVAL_MS);
  }

  componentWillUnmount() {
    this.unobserve();
  }

  unobserve = () => {
    window.clearInterval(this.lazyLoadIntervalId);
    this.setState({ isIntersecting: false, disabled: true });
  };

  render() {
    const { loading, rootMargin } = this.props;
    const lazyLoadClassNames = cx(styles.lazyLoadObserver, {
      [styles.lazyLoadObserverLoading]: loading,
    });

    return (
      <IntersectionObserver
        disabled={this.state.disabled}
        onChange={this.onIntersectionChange}
        rootMargin={rootMargin}
      >
        <div className={lazyLoadClassNames}>
          {loading && <DotLoadingIndicator data-testid="lazy-loading-loader" />}
        </div>
      </IntersectionObserver>
    );
  }
}

LazyLoading.propTypes = {
  loading: PropTypes.bool.isRequired,
  onLazyLoad: PropTypes.func.isRequired,
  rootMargin: PropTypes.string,
};

LazyLoading.defaultProps = {
  loading: false,
  onLazyLoad: () => {
    console.warn('<LazyLoading> please define the [onLazyLoad] handler!'); // eslint-disable-line
  },
};

export default LazyLoading;
